<template>
  <svg :fill="color" x="0" y="0" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
    <path d="M36.11 1c.46 0 .92.17 1.26.52.7.7.7 1.83 0 2.53L16.42 25l20.95 20.95c.7.7.7 1.83 0 2.53-.7.7-1.83.7-2.53 0L12.63 26.26a1.77 1.77 0 0 1-.52-1.26c0-.47.19-.93.52-1.26L34.84 1.52c.35-.35.81-.52 1.27-.52z"/>
  </svg>
</template>

<script>
export default {
  name: 'IconChevronLeft',
  props: {
    color: {
      type: String,
      default: '#24b9ec'
    }
  }
}
</script>
